import { Outlet } from "react-router-dom";
import R_Sidebar from "../../components/R_Sidebar";
import { useHubSpotScript } from "../../utils/useHubSpotScript";
import "./r_layout.css";

const R_Layout = () => {
  useHubSpotScript();

  return (
    <div className="app-layout">
      <div className="app-body">
        <R_Sidebar />

        <main className="app-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};


export default R_Layout;
